<template>
  <section class="app-main">
    <div class="page">
      <keep-alive :include="cachedViews">
        <router-view :key="key"></router-view>
      </keep-alive>
    </div>
  </section>
</template>

<script>
export default {
    name: 'AppMain',
    computed: {
        cachedViews() {
            return this.$store.state.tagsView.cachedViews;
        },
        key() {
            return this.$route.fullPath;
        }
    }
};
</script>

<style scoped>
.app-main {
  /*84 = navbar + tags-view = 50 +34 */
  height: calc(100vh - 137px);
  padding: 10px;
  position: relative;
  overflow: hidden;
  background: hsla(0,0%,80%,.23);
}
.page{
    height: calc(100% - 20px);
    background: #fff;
    border-radius: 3px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    padding: 10px;
}
</style>

